import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './registrationTypography.css';
import WebsitePackageBuilder from './App';
import ErrorBoundary from './ErrorBoundary';

window.onerror = (message, source, lineno, colno, error) => {
  console.error('Global window error captured:', {
    message,
    source,
    lineno,
    colno,
    error,
    stack: error?.stack
  });
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <WebsitePackageBuilder />
    </ErrorBoundary>
  </React.StrictMode>
);
